export default "__VITE_ASSET__CdiU_5um__"